<template>
  <div id="moreInfo">
    <el-dialog
      :title="$t('MoreInfo')"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="viewClose"
    >
      <div class="info">
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-longtime.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('total_print_time')}}</div>
            <div class="rightBottom">{{longTime}}</div>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-wireRod.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('total_filament_consumption')}}</div>
            <div class="rightBottom">{{wireRod}}</div>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-printeTimes.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('print_count')}}</div>
            <div class="rightBottom">{{printeTimes}}</div>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-bindTime.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('binding_time')}}</div>
            <div class="rightBottom">{{bindTime}}</div>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-firmware.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('FirmwareVersion')}}</div>
            <div class="rightBottom">{{firmware}}</div>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-CN.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('CNCode')}}</div>
            <div class="rightBottom">{{CN}}</div>
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <img src="../../../assets/imgs/moreInfo/icon-Mac.png"/>
          </div>
          <div class="itemRight">
            <div class="rightTop">{{$t('mac_address')}}</div>
            <div class="rightBottom">{{Mac}}</div>
          </div>
        </div>
        <div class="closeBtn" @click="viewClose()">{{$t('close')}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 这里导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
  name: "moreInfo",
  // 引入的组件需要注入到对象中
  components: {},
  // 定义props属性
  props: {
    visible: Boolean,
    id: [String,Number]
  },
  // 数据层
  data() {
    return {
      dialogVisible: false,
      longTime: '',
      wireRod: '',
      printeTimes: '',
      bindTime: '',
      firmware: '',
      CN: '',
      Mac: '',
    };
  },
  computed: {},
  watch: {
    visible: function (val) {
      this.dialogVisible = val;
    },
    dialogVisible: function (val) {
      if (val) {
        // let curPrinter = JSON.parse(localStorage.getItem('curPrinter'))
        let curPrinter = undefined;
        if(this.id) {
          curPrinter = this.$store.getters.GET_CLOUD_PRINTER_LIST.find(item => item.id==this.id);
        } else {
          curPrinter = this.$store.getters.GET_CUR_PRINTER
        }
        if(!!curPrinter && Object.keys(curPrinter).length > 0) {
          this.longTime = curPrinter.base.print_totaltime;
          this.wireRod = curPrinter.base.material_used;
          this.printeTimes = curPrinter.base.print_count;
          this.bindTime = this.$common.formatterTime(curPrinter.base.create_time);
          this.firmware = curPrinter.base.firmware_version;
          this.CN = curPrinter.base.description;
          this.Mac = curPrinter.base.machine_mac;
        } else {
          this.longTime = '';
          this.wireRod = '';
          this.printeTimes = '';
          this.bindTime = '';
          this.firmware = '';
          this.CN = '';
          this.Mac = '';
        }
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  deactivated() {
    this.viewClose();
  },
  // 方法
  methods: {
    viewClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入公共css类 */
#moreInfo {
  :deep(.el-dialog__header) {
    text-align: center;
    padding-top: 10px;
    .el-dialog__title {
      // height: 18px;
      
      // font-weight: normal;
      // font-size: 13px;
      // line-height: 18px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  :deep(.el-dialog__body) {
    padding: 0px;
  }
  :deep(.el-dialog__footer) {
    padding-top: 20px;
  }
  :deep(.el-dialog) {
    width: 340px;
    box-sizing: border-box;
  }
  .info {
    padding: 20px;
    .item {
      display: flex;
      margin-bottom: 14px;
      .itemLeft {
        margin-right: 4px;
        img{
          width: 20px;
          height: 20px;
        }
      }
      .itemRight {
        .rightTop {
          height: 18px;
          
          font-weight: normal;
          font-size: 13px;
          color: var(--first-text-color);
          line-height: 18px;
        }
        .rightBottom {
          height: 18px;
          
          font-weight: normal;
          font-size: 13px;
          color: var(--three-text-color);
          line-height: 18px;
        }
      }
    }
    .closeBtn {
      width: 100%;
      height: 24px;
      line-height: 24px;
      text-align: center;
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #262E30;
      margin-top: 28px;
      
      
      font-weight: normal;
      font-size: 13px;
      color: #262E30;
      cursor: pointer;
    }
  }
}
</style>
